<template>
  <div class="content extended-forms">
    <div class="row">
      <ArtistSelect
        class="col-md-12"
        @memberChangeEvent="getArtistInfo"
        :is-filter="true"
        :include-unit-artist="true"
        :initial-unit-id="$route.query.unitId ? parseInt($route.query.unitId, 10) : null"
        :initial-member-id="$route.query.artistId ? parseInt($route.query.artistId, 10) : null"
      />
    </div>
    <div class="row">
      <div class="col-md-2">
        <el-select @change="getCollections" class="select-primary" size="large" placeholder="선택" v-model="state.state">
          <el-option v-for="option in state.options" class="select-primary" :value="option.value" :label="option.label" :key="option.label" />
        </el-select>
      </div>
      <div class="col-md-2">
        <el-select @change="getCollections" class="select-primary" size="large" placeholder="선택" v-model="gubun.gubun">
          <el-option v-for="option in gubun.options" class="select-primary" :value="option.value" :label="option.label" :key="option.label" />
        </el-select>
      </div>
      <span v-show="gubun.gubun === 2" @click="toggleSearchForm"><a href="#">상세검색</a></span>
      <base-button @click="goCollectionForm" type="default">등록</base-button>
      <div class="col-md-4">
        <h4 class="card-title text-left"></h4>
        <base-radio name="card" inline v-model="viewType">카드</base-radio>
        <base-radio name="list" inline v-model="viewType">리스트</base-radio>
      </div>
    </div>
    <div v-if="showSearchForm && gubun.gubun === 2" class="row">
      <div class="col-md-4">
        <h4 class="card-title text-left">기간</h4>
        <div class="row">
          <div class="col-md-12 text-left">
            <el-date-picker type="daterange" start-placeholder="검색 시작일" end-placeholder="검색 종료일" v-model="searchPeriod" />
          </div>
        </div>
      </div>
      <div class="col-md-2">
        <h4 class="card-title text-left">구분</h4>
        <div class="row">
          <div class="col-md-12 text-left">
            <el-select class="select-primary" size="large" placeholder="선택" v-model="searchType.type">
              <el-option v-for="option in searchType.options" class="select-primary" :value="option.value" :label="option.label" :key="option.label" />
            </el-select>
          </div>
        </div>
      </div>
      <div class="col-md-2">
        <h4 class="card-title text-left">검색어</h4>
        <div class="row">
          <div class="col-md-12 text-left">
            <base-input placeholder="검색어" v-model="searchWord">
              <span slot="helpBlock" class="form-text" />
            </base-input>
          </div>
        </div>
      </div>
      <div class="col-md-2">
        <h4 class="card-title text-left">&nbsp;</h4>
        <div class="row">
          <div class="col-md-12 text-left">
            <base-button @click="getCollections('detail')" type="default">검색</base-button>
          </div>
        </div>
      </div>
    </div>

    <div class="row" v-if="viewType == 'card'">
      <div class="col-sm-3" v-for="(item, index) in list">
        <CardLayout
          :key="index"
          :contentId="item.collectionId"
          :fileIds="item.fileIds"
          :title="item.title"
          :state="item.state"
          :viewCount="item.viewCount"
          :commentCount="item.commentCount"
          :likeCount="item.likeCount"
          :pinCount="item.pinCount"
          :regDate="item.regTime"
          :btnDelete="true"
          :btnDetail="true"
          @contentDetail="goCollectionDetail"
          @deleteContent="deleteCollection"
        />
      </div>
    </div>
    <div class="row" v-if="viewType == 'list'">
      <div class="col-md-12" v-for="(item, index) in list">
        <div class="row">
          <div class="col-md-8">[{{ item.collectionId }}] {{ item.title | truncate(80) }} ({{ item.regTime }})</div>
          <div class="col-md-4">
            <base-button class="default" @click.prevent="goCollectionDetail({ contentId: item.collectionId })">상세</base-button>
            <base-button v-if="item.isVisible != 0 && item.state != -1" class="btn-danger col-2" @click="deleteCollection(item)" type="success"
              >삭제</base-button
            >
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <base-pagination class="pagination-no-border" v-model="currentPage" :pageCount="totalPages" />
    </div>
  </div>
</template>
<script>
import ArtistSelect from "@/pages/Components/ArtistSelect.vue";
import CardLayout from "@/pages/Components/CardLayout.vue";
import { BaseInput, BaseButton, BasePagination } from "@/components/index";
import swal from "sweetalert2";
import { URLUtils } from "@/util/URLUtils";
import moment from "moment";
import { formatDateTime } from "@/util/DateUtils";
import { UserData } from "@/util/UserData";

export default {
  components: {
    ArtistSelect,
    CardLayout,
    BaseInput,
    BaseButton,
    BasePagination,
  },
  async created() {
    this.viewType = UserData.get("currentViewType") ?? "card";
    if (!_.isEmpty(this.$route.query)) {
      if (this.$route.query.state) {
        this.state.state = parseInt(this.$route.query.state);
      } else {
        this.state.state = null;
      }
      if (this.$route.query.gubun) {
        this.gubun.gubun = parseInt(this.$route.query.gubun);
      }
      if (this.$route.query.searchType) {
        this.searchType.type = parseInt(this.$route.query.searchType);
      }
      if (this.$route.query.searchWord) {
        this.searchWord = this.$route.query.searchWord;
      }
      if (this.$route.query.startDate && this.$route.query.endDate) {
        this.searchPeriod = [moment(this.$route.query.startDate, "YYYY-MM-DD").toDate(), moment(this.$route.query.endDate, "YYYY-MM-DD").toDate()];
      }
    }
  },
  data() {
    return {
      showSearchForm: false,
      searchWord: null,
      searchType: {
        type: 1,
        options: [
          { label: "해시태그", value: 1 },
          { label: "유저이름", value: 2 },
          { label: "제목+내용", value: 3 },
        ],
      },
      state: {
        state: 1,
        options: [
          { label: "전체", value: null },
          { label: "표시", value: 1 },
          { label: "숨김", value: 0 },
          { label: "삭제", value: -1 },
        ],
      },
      gubun: {
        gubun: 2,
        options: [{ label: "전체갤러리", value: 2 }],
      },
      searchPeriod: [],
      list: [],
      hotList: [],
      currentPage: 1,
      totalPages: 1,
      unitId: null,
      memberId: null,
      viewType: "card",
    };
  },
  watch: {
    viewType: {
      handler() {
        UserData.set("currentViewType", this.viewType);
      },
    },
    currentPage: {
      handler() {
        this.getCollections(this.$route.query.withParams, this.currentPage);
      },
    },
  },
  methods: {
    async getArtistInfo(param) {
      this.unitId = param.unitId;
      this.memberId = param.memberId;
      await this.getCollections();
    },
    async getCollections(withParams, page) {
      const queryParams = {
        unitId: this.unitId,
        artistId: this.memberId || undefined,
        state: this.state.state ?? undefined,
        gubun: this.gubun.gubun || undefined,
      };

      let url = null;
      if (this.gubun.gubun == 1) {
        url = "/collection/hotCollections";
      } else if (this.gubun.gubun == 2) {
        url = "/collection/";
      }
      const params = { unitId: this.unitId, artistId: this.memberId, state: this.state.state };
      params.currentPage = page ? page : 1;
      if (withParams == "detail" || this.$route.query.withParams == "detail") {
        this.showSearchForm = true;
        if (!this.searchPeriod) {
          window.Toast.error("검색기간을 입력해 주세요");
          return;
        }
        if (this.searchPeriod) {
          queryParams.startDate = this.searchPeriod?.[0] ? moment(this.searchPeriod[0]).hour(0).minute(0).second(0).toISOString(true) : undefined;
          queryParams.endDate = this.searchPeriod?.[1] ? moment(this.searchPeriod[1]).hour(23).minute(59).second(59).toISOString(true) : undefined;
          params.startDate = this.searchPeriod?.[0] ? moment(this.searchPeriod[0]).hour(0).minute(0).second(0).toISOString() : undefined;
          params.endDate = this.searchPeriod?.[1] ? moment(this.searchPeriod[1]).hour(23).minute(59).second(59).toISOString() : undefined;
        }
        queryParams.searchWord = this.searchWord;
        queryParams.searchType = this.searchType.type;
        queryParams.withParams = "detail";
        params.startTime = this.searchPeriod[0];
        params.endTime = this.searchPeriod[1];

        if (this.searchWord != "" && this.searchWord != null) {
          if (this.searchType.type == 1) {
            params.searchTag = this.searchWord;
          } else if (this.searchType.type == 2) {
            params.userName = this.searchWord;
          } else if (this.searchType.type == 3) {
            params.content = this.searchWord;
          }
        }
      }
      const path = `/collection/collections?${URLUtils.objectToQueryString(queryParams)}`;
      if (this.$route.fullPath !== path) {
        try {
          await this.$router.push(path);
        } catch (ex) {}
      }
      if (!params.unitId) {
        window.Toast.error("잘못된 접근입니다");
        return;
      }
      return this.$axios
        .get(url, {
          params,
        })
        .then((res) => {
          this.list = res.data.data.data.map((d) => {
            d.regTime = formatDateTime(d.regTime);
            return d;
          });
          this.totalPages = Number(res.data.data.page);
          for (let i = 0; i < this.list.length; i++) {
            this.list[i].fileIds = [this.list[i].coverFileId];
            for (let j = 0; j < this.list[i].medias.length; j++) {
              this.list[i].fileIds.push(this.list[i].medias[j].fileId);
            }
          }
        });
    },

    async deleteCollection(param) {
      swal
        .fire({
          title: "삭제 확인",
          text: `${param.title} 갤러리 삭제하시겠습니까?`,
          type: "warning",
          showCancelButton: true,
          customClass: {
            confirmButton: "btn btn-danger btn-fill",
            cancelButton: "btn btn-cancel btn-fill",
          },
          confirmButtonText: "삭제",
          cancelButtonText: "취소",
          buttonsStyling: false,
        })
        .then(async (selection) => {
          if (selection.value) {
            try {
              const contentId = param.contentId ?? param.collectionId;
              return this.$axios
                .put(`/collection/${contentId}/state`, {
                  params: { unitId: this.unitId, state: -1 },
                })
                .then((res) => {
                  window.Toast.success("갤러리 삭제 되었습니다");
                  this.getCollections();
                });
            } catch (err) {
              window.Toast.error("갤러리 삭제 중 에러가 발생하였습니다.");
            }
          }
        });
    },

    goCollectionDetail(param) {
      this.$router.push(`/collection/collectionDetail?collectionId=${param.contentId}`);
    },

    goCollectionForm() {
      this.$router.push(`/collection/collectionForm?unitId=${this.unitId}`);
    },
    toggleSearchForm() {
      this.showSearchForm = !this.showSearchForm;
    },
  },
};
</script>
<style scoped lang="scss">
.content {
  .row {
    margin-bottom: 20px;
  }
}
</style>
